import { useRsvpStore } from '@/stores/rsvp/rsvp.store';
import Tr from '@/i18n/translation';
import ProductRoutes from '../routeNames';

import {
  RsvpMainForm,
  RsvpGuestForm,
} from '@/components/clients/rsvp/components/form/interface';

export default [
  {
    path: '',
    name: ProductRoutes.rsvp,
    component: RsvpMainForm,
    meta: {
      stayInPosition: true,
    },
  },
  {
    path: ':guestId',
    name: 'RsvpGuestForm',
    component: RsvpGuestForm,
    beforeEnter: (to, _from, next) => {
      const clientId = to.params.id;
      const guestId = to.params.guestId;
      const rsvpStore = useRsvpStore();
      if (rsvpStore.getNumberOfGuests >= guestId) {
        next();
      } else {
        next(Tr.i18nRoute({ name: 'Rsvp', params: { id: clientId } }));
      }
    },
    meta: {
      stayInPosition: true,
    },
  },
];
